module.exports = __webpack_public_path__ + "IMZicon.png?de7f4eff38bc6615f33de4aac99e144b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/IMZicon.png
// module id = 39
// module chunks = 0